import { connectorOAuthCoordinator } from "@/lib/oauth/connectorOAuthCoordinator";
import type { SourceConnectionStatusChangedWireEvent } from "@/lib/realtime/normalizeResourceEventPayload";
import { usePluginStore } from "@/stores/usePluginStore";
import { useSourceConnectionStore } from "@/stores/useSourceConnectionStore";
import { useSourceCredentialStore } from "@/stores/useSourceCredentialStore";

/**
 * Applies source status push data to credential and connection stores.
 *
 * Thread hydration is handled by useConversationThreadSync via toolResultAppliedEvent.
 */
export function handleSourceConnectionStatusChangedEvent(
  event: SourceConnectionStatusChangedWireEvent,
): void {
  const credentialErrorCode = event.credentialStatus
    ? event.credentialStatus === "error"
      ? event.errorCode
      : null
    : undefined;
  useSourceCredentialStore.getState().applyCredentialPatch({
    credentialPublicId: event.credentialPublicId,
    workspacePublicId: event.workspacePublicId,
    status: event.credentialStatus,
    errorCode: credentialErrorCode,
    displayAccount: event.displayAccount,
  });
  useSourceConnectionStore.getState().applyConnectionPatch({
    connectionPublicId: event.connectionPublicId,
    credentialPublicId: event.credentialPublicId,
    workspacePublicId: event.workspacePublicId,
    projectPublicId: event.projectPublicId,
    credentialStatus: event.credentialStatus,
    effectiveStatus: event.effectiveStatus,
    enabled: event.enabled,
    displayAccount: event.displayAccount,
  });

  if (event.attemptPublicId) {
    void connectorOAuthCoordinator
      .confirmAttempt(event.attemptPublicId)
      .catch(() => undefined);
  }
  void useSourceCredentialStore.getState().refreshLoadedWorkspaces();
  void useSourceConnectionStore.getState().refreshLoadedProjects({
    projectPublicId: event.projectPublicId,
    workspacePublicId: event.workspacePublicId,
  });
  if (event.workspacePublicId) {
    usePluginStore
      .getState()
      .invalidateWorkspace(event.workspacePublicId, event.projectPublicId ?? null);
  }
}
